// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Nll2","title":"BackImages_title__1vmkb","images":"BackImages_images__3jZk-"};